// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D7-c","col":"styles_col__1-xOY"};